<template>
  <div class="amem">
    <section class="amem__kpis" data-tour="admin-members-kpis">
      <article class="sui-card amem__kpi">
        <span class="amem__kpi-label">고객</span>
        <span class="amem__kpi-value">{{ members.length }}<em>곳</em></span>
      </article>
      <article class="sui-card amem__kpi">
        <span class="amem__kpi-label">주문한 곳</span>
        <span class="amem__kpi-value">{{ orderedCount }}<em>곳</em></span>
      </article>
    </section>

    <section class="sui-card sui-card--flush" data-tour="admin-members-list">
      <div class="sui-toolbar" data-tour="admin-members-toolbar">
        <label class="sui-search">
          <AppIcon icon="mdi-magnify" :size="17" />
          <input
            v-model.trim="keyword"
            type="search"
            placeholder="시설명 · 아이디 · 대표자 · 기관기호"
            @keyup.enter="load"
          />
        </label>
        <button type="button" class="sui-btn" :disabled="loading" @click="load">
          <AppIcon icon="mdi-magnify" :size="16" />
          검색
        </button>
        <span class="sui-toolbar__spacer" />
        <button type="button" class="sui-btn" :disabled="loading" @click="load">
          <AppIcon icon="mdi-refresh" :size="16" />
          새로고침
        </button>
      </div>

      <p v-if="errorMessage" class="amem__error">
        <AppIcon icon="mdi-alert-outline" :size="16" />
        {{ errorMessage }}
      </p>
      <div v-if="members.length" class="sui-table-wrap">
        <table class="sui-table">
          <thead>
            <tr>
              <th>기관</th>
              <th>아이디</th>
              <th>대표 · 연락처</th>
              <th>가입일</th>
              <th>주문</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in members" :key="row.mCode">
              <td>
                <span class="amem__org">
                  <span class="sui-table__strong">{{ row.orgName }}</span>
                  <span v-if="row.signupSource === 'WEB'" class="amem__chip">쇼핑몰</span>
                </span>
                <span class="sui-table__sub">{{ row.longtermCode || '기관기호 없음' }}</span>
              </td>
              <td>
                <span>{{ row.userId || '-' }}</span>
              </td>
              <td>
                <span>{{ row.bossName || '-' }}</span>
                <span class="sui-table__sub">{{ row.bossPhone || row.orgPhone || row.bossEmail || '-' }}</span>
              </td>
              <td>
                <span>{{ formatDate(row.joinedAt) }}</span>
              </td>
              <td>
                <span v-if="(row.orderCount || 0) > 0" class="sui-table__strong">
                  {{ row.orderCount }}건
                </span>
                <span v-else>없음</span>
                <span v-if="row.lastOrderedAt" class="sui-table__sub">
                  최근 {{ formatDate(row.lastOrderedAt) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="sui-empty">
        <AppIcon icon="mdi-account-multiple-outline" :size="32" />
        <p>{{ loading ? '불러오는 중입니다…' : '조건에 맞는 고객이 없습니다.' }}</p>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchAdminMembers, type AdminMemberRow } from '@/api/admin'

const members = ref<AdminMemberRow[]>([])
const keyword = ref('')
const loading = ref(false)
const errorMessage = ref('')

function formatDate(value?: string | null) {
  const raw = String(value || '').trim()
  if (!raw) return '-'
  return raw.slice(0, 10)
}

const orderedCount = computed(
  () => members.value.filter((row) => (Number(row.orderCount) || 0) > 0).length,
)

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    members.value = await fetchAdminMembers(keyword.value)
  } catch (error) {
    members.value = []
    errorMessage.value = error instanceof Error ? error.message : '고객 목록을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  void load()
})
</script>

<style lang="scss" src="./AdminMembersPage.scss"></style>
